import { ChevronDown } from '@squareup/dex-icons/dex/control';
import { ChildrenProp } from '@squareup/dex-types-shared-ui';
import { TrackedProps } from '@squareup/dex-types-shared-utils';
import { Box, Paragraph20 } from '@squareup/dex-ui-shared-base';
import { commonIconStyles } from '@squareup/dex-ui-shared-icon-styles';
import clsx from 'clsx';
import React, { FC, useCallback, useState } from 'react';

import { NativeButton } from '../NativeButton';

import styles from './navigation-item.module.css';

interface NavigationItemCollapseProps {
  text: string;
  forceOpen?: boolean | undefined;
}

const NavigationItemCollapse: FC<
  NavigationItemCollapseProps & ChildrenProp & TrackedProps
> = ({ children, text, trackingId, trackingExtra, forceOpen = false }) => {
  const [isOpen, setIsOpen] = useState(forceOpen);

  const onClick = useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen, setIsOpen]);

  return (
    <>
      <NativeButton
        trackingId={trackingId}
        testId={trackingId}
        trackingExtra={trackingExtra}
        className={clsx(styles['sub-item'], styles['item-a'], styles.collapse)}
        onClick={onClick}
      >
        <Box
          padding={{
            horizontal: '1x',
            vertical: '0.5x',
          }}
          border={{ radius: 'standard' }}
          className={clsx(styles.inner)}
        >
          <Paragraph20 margin={{ right: '0.75x' }}>{text}</Paragraph20>
          <ChevronDown
            className={clsx(
              styles.icon,
              commonIconStyles['icon-fill-current-color'],
              !isOpen && commonIconStyles['icon-current-color-30'],
              isOpen && commonIconStyles['icon-current-color-20'],
              isOpen && commonIconStyles['icon-rotate-180']
            )}
          />
        </Box>
      </NativeButton>
      {isOpen && <Box padding={{ left: '1x' }}>{children}</Box>}
    </>
  );
};

export { NavigationItemCollapse };
